import React from 'react';

import classNames from 'classnames';
import failImg from 'assets/images/failModalImg.svg';
import { ButtonRect } from 'components';

import { DefaultModalProps } from './types';
import s from '../GameModal.module.scss';
import { useLanguageDirection, useTranslation } from 'appState';

const Incorrect: React.FC<DefaultModalProps> = ({ text, onClick, header }) => {
  const lang = useTranslation('Children');
  const dir = useLanguageDirection();

  return (
    <>
      <div className={s.modal}>
        <div>
          <div className={classNames(s.feedbackIcon)} />
          <h6 dir={dir}>{ header ?? 'Incorrect' }</h6>
          <p dir={dir}>{ text ?? 'Click ‘Next’ to start another trial' }</p>
        </div>
        <img className={s.modalImg} src={failImg} alt="Incorrect illustration" />
      </div>
      <ButtonRect
        text={lang.next}
        onClick={onClick}
        isVisible={true}
        className={s.cornerBtn}
      />
    </>
  );
};

export default Incorrect;
